/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_LabelInputs */

const cs_builder_prop_label = /** @type {(inputs: Builder_Prop_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Štítek`)
};

const en_builder_prop_label = /** @type {(inputs: Builder_Prop_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

/**
* | output |
* | --- |
* | "Label" |
*
* @param {Builder_Prop_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_label = /** @type {((inputs?: Builder_Prop_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_label(inputs)
	return cs_builder_prop_label(inputs)
});